import { Component, inject, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { SelectUserListComponent } from '@app/shared/components/select-user-list/select-user-list.component';
import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { GroupsDataService } from '@app/shared/services/groups-data.service';
import { UsersDataService } from '@app/shared/services/users-data.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { SelectAdminGroupDialogData } from '@app/shared/types/models/group/group.model';
import { User } from '@app/shared/types/models/user/user.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-select-group-admin-dialog',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, SelectUserListComponent, UiButtonComponent],
  templateUrl: './select-group-admin-dialog.component.html'
})
export class SelectGroupAdminDialogComponent implements OnInit {
  private readonly companyGroupsService: GroupsDataService = inject(GroupsDataService);
  private readonly activeCompanyService: ActiveCompanyService = inject(ActiveCompanyService);
  private readonly dialogRef: MatDialogRef<SelectGroupAdminDialogComponent> = inject(
    MatDialogRef<SelectGroupAdminDialogComponent>
  );
  private readonly usersDataService: UsersDataService = inject(UsersDataService);
  private readonly dialogData: SelectAdminGroupDialogData = inject(MAT_DIALOG_DATA);

  protected readonly activeCompany: Signal<Company | undefined> = this.activeCompanyService.activeCompany;
  protected readonly companyUsers: Signal<User[]> = this.usersDataService.getCompanyUsers(this.activeCompany()?.id);
  protected readonly selectedUser: WritableSignal<string> = signal<string>(undefined);
  protected readonly preselectedUser: WritableSignal<string> = signal<string>(undefined);

  public constructor() {
    this.preselectedUser.set(this.dialogData.preselectedUser?.id);
  }

  protected save(): void {
    this.companyGroupsService.setGroupAdmin(this.activeCompany()!.id, this.dialogData.group, this.selectedUser());
    this.dialogRef.close();
  }

  public ngOnInit(): void {
    this.selectedUser.set(this.preselectedUser());
  }
}
